import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Educon } from "../components/pages/Educon";
import { Expociencias } from "../components/pages/expociencias";
import { ExpocienciasConfirma } from '../components/pages/ExpocienciasConfirma'
import { ExpocienciasEtapaEstatal } from "../components/pages/ExpocienciasEtapaEstatal";
import { SemanaDePosgrado } from "../components/pages/SemanaDePosgrado";
import { SignIn } from "../components/pages/SignIn";
import { Menu } from "../components/pages/admin/Menu";
import { EduconConfirma } from "../components/pages/EduconConfirma";
import { Biotecnologia } from "../components/pages/Biotecnologia";
import { ConfirmarRegistro } from "../components/pages/ConfirmarRegistro";
import { VisualizarRegistro } from "../components/pages/VisualizarRegistro";
import { Bioeconomics } from "../components/pages/Bioeconomics";
import { Simac } from "../components/pages/Simac";
import { Rnav } from "../components/pages/rnav";
// import { SemanaDePosgradoAdmin } from "../components/pages/SemanaDePosgradoAdmin";
import { SemanaDePosgradoPanel } from "../components/pages/SemanaDePosgradoPanel";
import { ReporteAsistencia } from "../components/pages/admin/ReporteAsistencia";
import { Testing } from "../components/pages/Testing";
import { RegistroGeneral } from "../components/pages/RegistroGeneral";
import { Dashboard } from "../components/pages/educon/index";
import RegistroConfirmado from "../components/pages/testing/RegistroConfirmado";


export const Routes = () => {
    return (
 

        <Router basename={process.env.REACT_APP_ROUTER_BASENAME}>
            <div>
                <Switch>
                    <Route exact path={"/testing/registro-confirmado/:referencia"} component={ RegistroConfirmado } />
                    <Route exact path={"/admin"} component={ Menu } />
                    <Route exact path={"/educon"} component={ Educon } />
                    <Route exact path={"/educon/dashboard"} component={ Dashboard } />
                    <Route exact path={"/admin/reporte-de-asistencia/:proy"} component={ ReporteAsistencia } />
                    <Route exact path={"/bioeconomics"} component={ Bioeconomics } />
                    <Route exact path={"/biotecnologia"} component={ Biotecnologia } />
                    <Route exact path={"/simac"} component={ Simac } />
                    <Route exact path={"/testing"} component={ Testing } />
                    <Route exact path={"/rnav"} component={ Rnav } />
                    <Route exact path={"/confirmar-registro/:ref"} component={ ConfirmarRegistro } />
                    <Route exact path={"/visualizar-registro/:ref"} component={ VisualizarRegistro } />

                    <Route exact path={"/expociencias"} >
                        <Expociencias />
                    </Route>
                    <Route exact path={"/expociencias/etapa-estatal"} >
                        <ExpocienciasEtapaEstatal />
                    </Route>
                    <Route exact path={"/expociencias/subir-comprobante/:id"} >
                        <ExpocienciasConfirma />
                    </Route>
                    {/* <Route exact path={"/educon"} >
                        <Educon />
                    </Route> */}
                    <Route exact path={"/educon/subir-comprobante/:id"} >
                        <EduconConfirma />
                    </Route>
                    <Route exact path={"/semana-de-posgrado"} >
                        <SemanaDePosgrado />
                    </Route>
                    <Route exact path={"/semana-de-posgrado/panel"} >
                        <SemanaDePosgradoPanel />
                    </Route>
                    <Route exact path={"/sign-in"} >
                        <SignIn />
                    </Route>
                    <Route exact path={"/:id"} component={ RegistroGeneral } />
                    <Route exact path={"/"}>
                        <SignIn />
                    </Route>
                    {/* <Route path={"/*"}>
                        <SignIn />
                    </Route> */}
                </Switch>
            </div>
        </Router>
    );
};
